import { z } from 'zod';
import { TypeOfAPIError, TypeOfAPIResponse } from '@ninja/api-client';
import { APIFactoryOptions, factory } from '../../config';

const responseSchema = z.object({
	isSuccess: z.boolean(),
});

const memberDetails = z.object({
	memberId: z.string(),
	passportNumber: z.string(),
	visaFileNumber: z.string(),
	emiratesIdNumber: z.number().optional(),
	occupationId: z.number().optional(),
	firstName: z.string().optional(),
	lastName: z.string().optional(),
	unifiedNumber: z.number().optional(),
	uploadRef: z.string(),
	salaryBand: z.number().optional(),
});

const requestSchema = z.object({
	encryptedJourneyId: z.string(),
	principalSalary: z.number().optional(),
	principalDetails: memberDetails.optional(),
	dependents: z.array(memberDetails).optional(),
});

const addMemberDetailsV2 = (options: APIFactoryOptions) =>
	factory(options).createAPIDefinition({
		url: 'Member/v2/add-member-details',
		method: 'POST',
		responseSchema,
		requestSchema,
	});

export default addMemberDetailsV2;

export type AddMemberDetailsV2Request = z.infer<typeof requestSchema>;

export type AddMemberDetailsV2Response = TypeOfAPIResponse<ReturnType<typeof addMemberDetailsV2>>;

export type AddMemberDetailsV2Error = TypeOfAPIError<ReturnType<typeof addMemberDetailsV2>>;
